class MobileVibrate {
  /**
   * Vibrate method
   * @param duration
   */
  private _vibrate = function (duration = 50) {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(duration)
    }
  }

  /**
   * Shortest tick vibrate
   */
  public tick = () => {
    this._vibrate(25)
  }

  /**
   * Short vibrate
   */
  public short = () => {
    this._vibrate(50)
  }

  /**
   * Middle vibrate
   */
  public middle = () => {
    this._vibrate(500)
  }

  /**
   * Long vibrate
   */
  public long = () => {
    this._vibrate(1000)
  }

  /**
   * Custom vibrate
   * @param duration Vibration duration in milliseconds
   */
  public vibrate = (duration: number) => {
    this._vibrate(duration)
  }
}

export default new MobileVibrate()
